<template>
  <div v-scroll-lock="sideOpen">
    <div :class="['side--background', sideOpen ? 'side--open' : '']">
      <section
        :class="{
          'user--modal': true,
          'side--open': sideOpen,
          'header--disabled': !$store.state.header_enabled,
        }"
      >
        <div
          class="close-cross"
          @click="
            $emit('closeSide');
            currentTab = -1;
          "
        >
          <CrossSVG />
        </div>
        <div class="tabs-row" :class="[getContrast('secondary_color')]">
          <div
            class="single-tab"
            @click="currentTab = 0"
            v-if="$store.state.system_settings.userSettingsTabs.personal"
            :class="{ active: currentTab == 0 }"
          >
            {{ toLocal("settings.personal_title") }}
          </div>
          <div
            class="single-tab"
            @click="currentTab = 1"
            v-if="$store.state.system_settings.userSettingsTabs.trainings"
            :class="{ active: currentTab == 1 }"
          >{{ toLocal('group_side.assigned_trainings') }}
          </div>
          <div
            class="single-tab"
            @click="currentTab = 2"
            v-if="$store.state.system_settings.userSettingsTabs.certificates"
            :class="{ active: currentTab == 2 }"
          >
            {{ toLocal("user_side.certificates") }}
          </div>
            <div
            v-if="$store.state.system_settings.userSettingsTabs.violations"
            class="single-tab"
            @click="currentTab = 3"
            :class="{ active: currentTab == 3 }"
          >
            {{ toLocal("settings.penalties") }}
          </div>
        </div>
        <div class="main-modal-container">
          <div class="edit-btn" v-if="currentTab == 1 && hasPermission('users.change_training_status')" @click="editMode = !editMode">
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.0458 3.17292L17.7472 0.909719C17.2901 0.459788 16.6703 0.207031 16.0239 0.207031C15.3776 0.207031 14.7577 0.459788 14.3006 0.909719L1.06256 13.9441C0.93148 14.0732 0.849197 14.2426 0.829368 14.4241L0.254931 19.5129C0.242364 19.6247 0.253885 19.7379 0.288741 19.845C0.323598 19.9521 0.381006 20.0508 0.45722 20.1346C0.533433 20.2184 0.626738 20.2854 0.731044 20.3313C0.835349 20.3772 0.948311 20.4009 1.06256 20.4009C1.09241 20.4009 1.12225 20.3993 1.15193 20.3961L6.32349 19.8305C6.50784 19.811 6.67986 19.73 6.81099 19.6009L20.0466 6.56652C20.5035 6.11635 20.76 5.50595 20.7599 4.86955C20.7597 4.23316 20.5029 3.62288 20.0458 3.17292ZM5.86037 18.2713L1.98231 18.6953L2.41293 14.8769L11.7234 5.70972L15.1708 9.10412L5.86037 18.2713ZM18.8969 5.43532L16.3197 7.97292L12.8731 4.57852L15.4495 2.04172C15.6019 1.89174 15.8085 1.80749 16.0239 1.80749C16.2394 1.80749 16.446 1.89174 16.5984 2.04172L18.8969 4.30412C19.0493 4.45414 19.1348 4.65759 19.1348 4.86972C19.1348 5.08185 19.0493 5.2853 18.8969 5.43532Z" fill="#B2B2B2"/>
            </svg>

          </div>
          <div class="user-name">
            <span>{{ user.name }} {{ user.last_name }}</span>
          </div>
          <UserSettings v-if="currentTab == 0" :user="user" />
          <UserTrainings v-if="currentTab == 1" :user="user" :editMode="editMode" />
          <UserDocs v-if="currentTab == 2" :user="user" />
          <UserViolations v-if="currentTab == 3" :user="user" />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import _ from "lodash";
import UserSettings from "./userside/UserSettings.vue";
import UserTrainings from "./userside/UserTrainings.vue";
import UserDocs from "./userside/UserDocs.vue";
import UserViolations from "./userside/UserViolations.vue";
import CrossSVG from "@/assets/images/icons/users/cross-gray.svg?inline";
export default {
  name: "UserSide",
  data: function () {
    return {
      currentTab: -1,
      addDocumentModal: false,
      trainings: [],
      trainingsCopy: [],
      filteredTrainings: [],
      filteredTrainingsCopy: [],
      groups: [],
      all_groups: [],
      all_filtered_groups: [],
      loadingTrainings: false,
      isExpired: false,
      shownExpiryDate: "",
      editingDocument: "",
      today: Date.now(),
      selectedFilter: 0,
      activeDropdownType: -1,
      activeDropdown: -1,
      showGroupDrowDown: false,
      searchInput: "",
      training_groups: [],
      filteredGroupIds: [],
      editMode: false,
      // changedIDs: [],
    };
  },
  components: {
    UserSettings,
    UserTrainings,
    UserSettings,
    UserViolations,
    UserDocs,
    CrossSVG,
  },
  props: {
    user: {
      type: Object,
    },
    allDocuments: {
      type: Array,
    },
    sideOpen: {
      type: Boolean,
      default: false,
    },
  },
  methods: {},
  watch: {
    sideOpen() {
      if (this.sideOpen) {
        this.currentTab = 0;
        this.userDeactivationDate = this.user.deactivation_date;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/_progressbars.scss";
@import "@/assets/scss/components/layout/users/_userSideScoped.scss";
</style>
